import Reports from './reports';
import API from './api';
import { defaultReportQueryParams } from '../utils/reports';

const api = new API();

export const URL_CREATIVE_EXPLORE_DATA = '/api/get_creative_explore_data';
const URL_CREATIVE_CLUSTER = '/api/get_creative_cluster';

let instance = null;

class CreativeExplore {
    constructor() {
        if (!instance) {
            instance = this;
        }

        return instance;
    }

    runQuery(params, options) {
        return new Promise((resolve, reject) => {
            api.getJson(URL_CREATIVE_EXPLORE_DATA, {
                method: 'POST',
                credentials: 'include',
                body: {
                    ...defaultReportQueryParams,
                    ...params,
                },
                cache: false,
                unique: true,
                ...options,
            })
                .then(response => {
                    if (response.status !== 0) {
                        reject(Reports.ERROR_RUN_QUERY);
                    }
                    resolve(response.value);
                })
                .catch(reject);
        });
    }

    getCreativeCluster(creativeImageHash, appId, creativeType, creativeWidth, creativeHeight) {
        const paramsDict = {
            creative_image_hash: creativeImageHash,
            creative_type: creativeType,
        };

        if (creativeWidth) paramsDict.creative_width = creativeWidth;
        if (creativeHeight) paramsDict.creative_height = creativeHeight;

        const params = new URLSearchParams(paramsDict);

        if (appId) params.append('app_external_uuid', appId);

        const url = `${URL_CREATIVE_CLUSTER}?${params.toString()}`;

        return new Promise((resolve, reject) => {
            api.getJson(url, {
                method: 'GET',
                credentials: 'include',
                unique: true,
                cache: true,
            })
                .then(response => {
                    if (response.status === 0) {
                        resolve(response.value);
                    } else {
                        reject(new Error('Fetching creative cluster failed'));
                    }
                })
                .catch(reject);
        });
    }
}

export default CreativeExplore;
